<template>
  <div class="row" v-if="userData.permissions['report_cards'] == 1">
    <div class="container-fluid">
      <div class="my-2" v-if="exammarks.length <= 0">
        <div class="mt-5 text-center">
          <b-spinner type="grow" variant="primary" label="Loading"></b-spinner>
        </div>
      </div>
      <div v-else>
        <div v-for="item in exammarks" :key="item.id" class="reportCard">
          <div style="font-family: Arial, sans-serif">
            <div class="row">
              <div class="col-4">
                <span v-if="userData.logo != 0"
                  ><img :src="getLogo(userData.logo)" height="80"/><br
                /></span>
                <span v-else
                  ><img src="@/assets/images/logo.png" height="80"/></span
                ><br />
              </div>
              <div class="col-4 d-flex justify-content-center">
                <div class="text-center">
                  <h5 style="color:black" class="text-uppercase mb-0">
                    {{ userData.school }}
                  </h5>
                  <span style="color:black;font-size:12px"
                    >Location : {{ userData.location }}</span
                  ><br />
                  <span style="color:black;font-size:12px"
                    >Telephone : {{ userData.contact }}</span
                  ><br /><br />
                  <span
                    style="color: black;font-size:13px"
                    class="text-uppercase text-decoration-underline"
                    ><b>{{ schoolterm.name }} {{ year }} Report</b></span
                  ><br /><br />
                </div>
              </div>
              <div class="col-4 d-flex justify-content-end">
                <img :src="getFiles(item.students.student_photo)" height="80" />
              </div>
            </div>
            <div class="d-flex justify-content-evenly">
              <div>
                NAME : {{ item.students.first_name }}
                {{ item.students.last_name }} <br />
                CLASS : {{ schoolclass.name }}
              </div>
              <div>
                STUDENT ID : {{ item.students.student_id }} <br />
                SCHOOL PAY CODE : {{ item.students.school_pay_code }}
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-10 mx-auto">
                <table class="table table-sm">
                  <tr class="text-uppercase">
                    <th>Subject</th>
                    <th>Competency</th>
                    <th>Score</th>
                    <th>Out of 20</th>
                    <th>General Remarks</th>
                    <th>Subject Teacher</th>
                  </tr>
                  <tr v-for="x in item.subjects" :key="x.id">
                    <td>{{ x.exam.name }}</td>
                    <td>
                      <div class="mb-3" v-for="y in x.marksdetails" :key="y.id">
                        {{ y.id }} {{ y.competencies[0].competency }} <br />
                        {{ y.competencies[0].description }}
                      </div>
                    </td>
                    <td>
                      <div class="mb-5" v-for="y in x.marksdetails" :key="y.id">
                        {{ y.mark[0].mark }}
                      </div>
                    </td>
                    <td>
                      <b>{{ calculateOutOf20(x.marksdetails) }} </b>
                    </td>
                    <td>
                      <div class="mb-5" v-for="y in x.marksdetails" :key="y.id">
                        {{ y.mark[0].remark }}
                      </div>
                    </td>
                    <td>
                      <div class="mb-5" v-for="y in x.marksdetails" :key="y.id">
                        {{ y.teacher.full_name }}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="d-flex justify-content-between mt-3 mb-4">
              <div>
                <h5>Grading scheme:</h5>
                <table>
                  <tr>
                    <td>85+</td>
                    <td>80 - 84</td>
                    <td>75 - 79</td>
                    <td>70 - 74</td>
                    <td>65 - 69</td>
                    <td>50 - 64</td>
                    <td>40 - 49</td>
                    <td>0 - 39</td>
                  </tr>
                  <tr>
                    <td>A+</td>
                    <td>A</td>
                    <td>B</td>
                    <td>C</td>
                    <td>D</td>
                    <td>E</td>
                    <td>F</td>
                    <td>G</td>
                  </tr>
                </table>
              </div>
              <div>
                <h5>Identifier Ranges:</h5>
                <table>
                  <tr>
                    <td>16.0 - 20.0</td>
                    <td>10.6 - 15.9</td>
                    <td>6.6 - 9.9</td>
                  </tr>
                  <tr>
                    <td>Level 3</td>
                    <td>Level 2</td>
                    <td>Level 1</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="d-flex justify-content-center mt-3 mb-4">
              <div>
                <h5>Grading Scale</h5>
                <table>
                  <tr>
                    <th>Identifier</th>
                    <th>Score Range</th>
                    <th>Descriptor</th>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>2.50 - 3.00</td>
                    <td>
                      <b>Outstanding:</b> Most or all LO's achieved for overall
                      achievement
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>1.50 - 2.49</td>
                    <td>
                      <b>Moderate:</b> Many LO's achieved, enough for overall
                      achievement
                    </td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>0.90 - 1.49</td>
                    <td>
                      <b>Basic:</b> Few LO's achieved, but not sufficient for
                      overall achievement
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <table>
              <tr>
                <td>
                  <u><b class="h6">Class Teacher:</b></u
                  ><br /><br /><span
                    >..........................................................................</span
                  ><br />
                </td>
                <td>
                  <u><b class="h6">Class Teacher's Comment:</b></u
                  ><br /><br /><span
                    >............................................................................................................................................</span
                  ><br />
                </td>
                <td>
                  <u><b class="h6">Signature:</b></u
                  ><br /><br /><span
                    >.............................................</span
                  ><br />
                </td>
              </tr>
              <tr>
                <td>
                  <u><b class="h6">Head Teacher:</b></u
                  ><br /><br /><span
                    >..........................................................................</span
                  ><br />
                </td>
                <td>
                  <u><b class="h6">Head Teacher's Comment:</b></u
                  ><br /><br /><span
                    >............................................................................................................................................</span
                  ><br />
                </td>
                <td>
                  <u><b class="h6">Signature:</b></u
                  ><br /><br /><span
                    >.............................................</span
                  ><br />
                </td>
              </tr>
            </table>

            <br /><br />
            <div class="d-flex justify-content-between">
              <span
                >Next Term Begins on :
                ......................................................</span
              >
              <span>Date of Issue: {{ currentDate }}</span>
            </div>

            <div class="pt-4 pb-0">
              <b>Key words used / Description of terms</b>
              <table class="table table-borderless" border="0">
                <tr>
                  <td>Competency</td>
                  <td>
                    The overall expected capability of a learner at the end of a
                    topic, term or year, after being exposed to a body of
                    knowledge, skills and values.
                  </td>
                </tr>
                <tr>
                  <td>Identifier</td>
                  <td>
                    Is a label/grade that distinguishes learners according to
                    their learning achievement of the set competencies
                  </td>
                </tr>
                <tr>
                  <td>Score</td>
                  <td>
                    Refers to the average of the scores attained for the
                    different learning outcomes that make up competency
                  </td>
                </tr>
              </table>
            </div>
            <span><img src="@/assets/images/approved.png" height="80"/></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center>
            <span class="text-primary h4"
              >You have no permission to view this Page.</span
            >
          </center>
          <img
            src="@/assets/images/profile-img.png"
            alt
            class="img-fluid"
          /><br /><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Report Cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      year: "",
      exammarks: [],
    };
  },
  mounted() {
    this.FilterData();
  },
  methods: {
    calculateOutOf20(marksdetails) {
      if (!marksdetails.length) return 0;
      let totalMarks = marksdetails.reduce(
        (sum, y) => sum + (y.mark[0]?.mark || 0),
        0,
      );
      let average = totalMarks / marksdetails.length;
      return ((average / 3) * 20).toFixed(2);
    },
    formatDate(date) {
      return date.toLocaleDateString("en-GB");
    },
    getLogo(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    async FetchStudents() {
      let url = `/findstudents/${this.schoolclass.id},${this.schoolterm.id},${this.year}`;
      await axios.get(url).then((response) => {
        this.students = response.data.students;
      });
    },
    FilterData() {
      let formData = new FormData();
      formData.append("schoolterm", this.$route.query.term);
      formData.append("year", this.$route.query.year);
      formData.append("schoolclass", this.$route.query.class);
      formData.append("student_id", this.$route.query.student_id);
      let url = "/viewexammarks";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.marks;
        setTimeout(() => {
          window.print();
          window.onafterprint = this.$router.go(-1);
        }, 1000);
      });
    },
  },
};
</script>

<style>
@media print {
  .reportCard {
    page-break-before: always;
  }
}
table,
th,
td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
}
</style>
